import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Lock, AlertCircle } from 'lucide-react';
import api from '../api';

const Login = ({ setAuth }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [ssoEnabled, setSsoEnabled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isExpired = new URLSearchParams(location.search).get('expired') === '1';

  // Récupère le token renvoyé par le callback SSO (fragment #sso_token=...)
  useEffect(() => {
    const m = window.location.hash.match(/sso_token=([^&]+)/);
    if (m) {
      localStorage.setItem('token', decodeURIComponent(m[1]));
      window.history.replaceState(null, '', window.location.pathname);
      setAuth(true);
      navigate('/');
      return;
    }
    // Affiche le bouton Microsoft seulement si le SSO est configuré côté serveur
    api.get('/auth/sso/status').then(r => setSsoEnabled(!!r.data?.enabled)).catch(() => {});
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/login', { username, password });
      localStorage.setItem('token', res.data.token);
      setAuth(true);
      navigate('/');
    } catch (err) {
      setError('Identifiants incorrects');
    }
  };

  const handleSsoLogin = () => {
    const base = (api.defaults.baseURL || '/api').replace(/\/api$/, '');
    window.location.href = `${base}/api/auth/sso/login`;
  };

  return (
    <div className="auth-container">
      <div className="auth-card glass-panel">
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
             <div style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '1rem', borderRadius: '50%' }}>
                <Lock size={32} color="var(--accent)" />
             </div>
          </div>
          <h2>Connexion Sécurisée</h2>
          <p style={{ color: 'var(--text-secondary)', marginTop: '0.5rem', fontSize: '0.875rem' }}>
            Accès au portail Tallem Facturation
          </p>
        </div>
        
        {isExpired && (
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.2)', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
            <AlertCircle size={20} color="var(--danger)" style={{ flexShrink: 0, marginTop: '2px' }} />
            <div>
              <h4 style={{ color: 'var(--danger)', margin: '0 0 0.25rem 0', fontSize: '0.9rem' }}>Déconnecté</h4>
              <p style={{ color: 'var(--danger)', margin: 0, fontSize: '0.8rem', opacity: 0.9 }}>
                Votre session a expiré ou a été réinitialisée. Veuillez vous reconnecter.
              </p>
            </div>
          </div>
        )}
        
        {error && <div style={{ color: 'var(--danger)', background: 'rgba(239, 68, 68, 0.1)', padding: '0.75rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.875rem', textAlign: 'center' }}>{error}</div>}
        
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="username" className="input-label">Identifiant</label>
            <input id="username" name="username" autoComplete="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="input-field" placeholder="admin" required />
          </div>
          <div className="input-group">
            <label htmlFor="password" className="input-label">Mot de passe</label>
            <input id="password" name="password" autoComplete="current-password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="input-field" placeholder="••••••••" required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ marginTop: '1rem' }}>
            Accéder au Portail
          </button>
        </form>

        {ssoEnabled && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '1.5rem 0', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>
              <div style={{ flex: 1, height: '1px', background: 'var(--border, rgba(148,163,184,0.3))' }} />
              ou
              <div style={{ flex: 1, height: '1px', background: 'var(--border, rgba(148,163,184,0.3))' }} />
            </div>
            <button type="button" onClick={handleSsoLogin} className="btn"
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem', background: '#fff', color: '#5e5e5e', border: '1px solid #d1d5db' }}>
              <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden="true">
                <rect x="1" y="1" width="10" height="10" fill="#f25022"/>
                <rect x="12" y="1" width="10" height="10" fill="#7fba00"/>
                <rect x="1" y="12" width="10" height="10" fill="#00a4ef"/>
                <rect x="12" y="12" width="10" height="10" fill="#ffb900"/>
              </svg>
              Se connecter avec Microsoft
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
